import { render, staticRenderFns } from "./AddCertificate.vue?vue&type=template&id=70a6d96a&"
import script from "./AddCertificate.vue?vue&type=script&lang=js&"
export * from "./AddCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports